import Image from 'react-bootstrap/Image'
import VillaniLogo from './../assets/Villani_Logo.png';
import MalettiLogo from './../assets/Maletti_Logo_NOBG.png';
import {UserDetail} from "./UserGeneric";

interface HeaderProps{
    isAuthenticated:Boolean;
    username?:string;
    loginHandler:()=>void;
    logoutHandler:()=>void;
    userdetailsHandler:()=>void;
}

//Questo comeponente rappresenta l'header dell'applicazione
export const Header:React.FC<HeaderProps> = ({isAuthenticated,username,loginHandler,logoutHandler,userdetailsHandler}) =>{
    return(
      <div className="container-fluid bg-white App-header" >
      <div className="row p-2 ">
          <div className="col my-auto">
              <Image src={VillaniLogo} width={80} height={80} className="img-fluid" ></Image>{'  '}
              <Image src={MalettiLogo} width={80} height={80} className="img-fluid" ></Image>{'  '}
          </div>
          <div className="col text-center my-auto">
              <h5 className='d-block d-sm-none App-title'>Geomarketing App</h5>
              <h3 className='d-none d-sm-block App-title'>Geomarketing App</h3>
          </div>
          <div  className="col my-auto" >
            <UserDetail username={username} isAuthenticated={isAuthenticated} signinHandler={loginHandler} signoutHandler={logoutHandler} userdetailsHandler={userdetailsHandler}  ></UserDetail>
          </div>
      </div>
  </div>
    );
}